import React from "react";
import "croppie/croppie.css";
import { Spinner } from "reactstrap";
import { authHeader } from "../../helpers/authHeader";
import { handleResponse } from "../../helpers/handleresponse";
import { securityHelper } from "../../helpers/securityHelper";
import { calculateImageSize } from "../../helpers/imageHelper";
import Slider, { createSliderWithTooltip } from "rc-slider";
import Rotate90DegreesCcwTwoToneIcon from "@material-ui/icons/Rotate90DegreesCcwTwoTone";
import { IconButton, LinearProgress } from "@material-ui/core";
import SaveTwoToneIcon from "@material-ui/icons/SaveTwoTone";
import CropTwoToneIcon from "@material-ui/icons/CropTwoTone";
import "./Cropper.css";
import CloseIcon from "@material-ui/icons/Close";
const Croppie = require("croppie");
const SliderWithTooltip = createSliderWithTooltip(Slider);

class InlineCropper extends React.Component {
  constructor(props) {
    super(props);

    this.handleZoomOut = this.handleZoomOut.bind(this);
    this.state = {
      zoom: 0,
      isLoading: false,
    };
  }

  componentDidMount() {
    this.init();
  }
  init = (reRender = false) => {
    if (this.cropper) {
      this.cropper.destroy();
    }
    if (this.props.containerStyle !== null || reRender) {
      this.cropper = new Croppie(document.getElementById("croppie-img" + this.props.parent), {
        viewport:
          this.props.settings.type !== "CIRCLE" && this.props.settings.type !== "SQUARE"
            ? { width: this.props.containerStyle.width, height: this.props.settings.style.maxHeight }
            : {
                width: this.props.settings.style.width,
                height: this.props.settings.style.height,
                type: this.props.settings.type === "CIRCLE" && "circle",
              },
        boundary:
          this.props.settings.type !== "CIRCLE" && this.props.settings.type !== "SQUARE"
            ? { width: this.props.containerStyle.width, height: this.props.settings.style.maxHeight }
            : { width: this.props.settings.style.width, height: this.props.settings.style.height },
        showZoomer: true,
        type: "base64",
        minZoom: -10,
        zoom: -1,
      });
      /*debugger*/
      this.handleZoomOut(0);
      let listNodes = document.getElementsByClassName("cr-vp-square");
      if (listNodes[0]) {
        listNodes[0].style.boxShadow = `0px 0px 2000px 2000px ${this.props.bgColor}`;
      }
      listNodes = document.getElementsByClassName("cr-vp-circle");
      if (listNodes[0]) {
        listNodes[0].style.boxShadow = `0px 0px 2000px 2000px ${this.props.bgColor}`;
      }
    }
  };
  componentDidUpdate(prevProps) {
    if (this.props.hideOverlay !== undefined && prevProps.hideOverlay !== this.props.hideOverlay) {
      if (this.props.hideOverlay === false) {
        this.init(true);
      }
    }
    if (
      (prevProps.containerStyle !== this.props.containerStyle && this.props.containerStyle !== undefined && this.props.containerStyle !== null && !this.cropper) ||
      prevProps.url !== this.props.url
    ) {
      this.init();
    }
    if (this.props.url !== undefined && prevProps.url !== this.props.url) {
      this.init();
    }
    if (this.props.isCropping !== prevProps.isCropping) {
      this.init();
    }
  }
  rotate = () => {
    this.cropper.rotate(90);
  };
  handleZoomOut(scale, controlled = false) {
    if (this.cropper !== undefined) {
      const cZoom = this.cropper.get().zoom;
      if (!controlled && scale === 0) {
        this.setState({ zoom: scale }, () => {
          this.cropper.setZoom(scale);
        });
        return;
      }
      if (controlled === true && scale !== undefined) {
        this.setState({ zoom: scale }, () => {
          this.cropper.setZoom(scale);
        });
        return;
      }
      if (cZoom !== this.state.zoom) {
        if (cZoom === 50) {
          this.cropper.setZoom(0);
          this.setState({ zoom: 0 });
          return;
        }
        this.setState({ zoom: cZoom });
      }
    }
  }
  handlRes = () => {
    this.setState({ isLoading: true });
    const size = { height: parseInt(this.cropper.options.boundary.height) * 4, width: parseInt(this.cropper.options.boundary.width) * 4 };
    this.cropper.result({ type: "base64", size }).then((res) => this.handleSave(res));
  };
  handleSave = (res) => {
    const fileInfo = {
      name: "cropped-" + securityHelper.createGuid(),
      size: calculateImageSize(res).inBytes,
      type: "image/png",
      file: res,
      isCropped: true,
    };
    const requestOptions = {
      method: "POST",
      headers: authHeader({ "Content-Type": "application/json" }),
      body: JSON.stringify(fileInfo),
    };
    fetch(`./api/files/`, requestOptions)
      .then(handleResponse)
      .then((file) => {
        this.props.onSave(file.url);
        this.setState({ isLoading: false });
      })
      .catch((err) => {
        this.setState({ isLoading: false });
      });
  };
  alignment = () => {
    switch (this.props.settings.alignment) {
      case "center":
        return "-90px";
      case "left":
        return "unset";
      case "right":
        return "-200px";
      default:
        break;
    }
  };
  render() {
    return (
      <React.Fragment>
        <div>
          {this.state.isLoading ? <Spinner style={{ position: "absolute", top: "50%", left: "50%", zIndex: 100, width: "3rem", height: "3rem" }} color="info" /> : null}
          <div id="inline-croppie-overlay" onWheel={this.handleZoomOut} className="inline-croppie-overlay" style={{ width: "100%", display: !this.props.hideOverlay && "none", position: "relative" }}>
            <img id={"croppie-img" + this.props.parent} src={`${this.props.url}?rndparam=${Date.now()}`} style={{ maxWidth: this.props.mailCrop ? "680px" : undefined }} />
            <div style={{ width: "50%", left: `25%`, bottom: "12px" }} className={`croppie-controllers pi-crop-${this.props.settings.type} `}>
              {/*   <ZoomOutIcon style={{ color: '#757575', margin: '-3px 10px' }} />
                           
                            <ZoomInIcon style={{ color: '#757575', margin: '-3px 10px' }} /> */}
              <div style={{ display: "inline-flex", margin: " 0px" }}>
                {/*   <IconButton onClick={this.rotate}>
                                    <Rotate90DegreesCcwTwoToneIcon />
                                </IconButton> */}
                <IconButton onClick={this.handlRes}>
                  <SaveTwoToneIcon />
                </IconButton>
                {/*    {!this.props.mailCrop ?  */}
                <IconButton onClick={() => this.props.cancel()}>
                  <CloseIcon />
                </IconButton>{" "}
                {/* : null} */}
              </div>
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
}
export default InlineCropper;
